import { render, staticRenderFns } from "./PopupProductVue.vue?vue&type=template&id=a46dc018&"
import script from "./PopupProductVue.vue?vue&type=script&lang=js&"
export * from "./PopupProductVue.vue?vue&type=script&lang=js&"
import style0 from "./PopupProductVue.vue?vue&type=style&index=0&id=a46dc018&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports